/* global API_HOSTNAME:false */
/* global dataLayer:false */
/* global getStorageItem:false */
/* global globalMethods:false */
/* global removeStorageItem:false */
/* global setStorageItem:false */

(function() {
	var accountDataTimestamp = getStorageItem('account_fetched_on');

	const handleErrorState = function() {
		removeStorageItem('account_fetched_on');
	};

	const refreshWebElements = function() {
		globalMethods.detectCountry();
		globalMethods.switchAppButtons();
		globalMethods.showSidebarActionBox();
	};

	var timestampBeforeOneDay = new Date(new Date().getTime() - (1 * 24 * 60 * 60 * 1000)).getTime();
	if (!accountDataTimestamp || accountDataTimestamp < timestampBeforeOneDay) {
		var request = new XMLHttpRequest();
		request.open('GET', API_HOSTNAME + '/user_context', true)
		request.withCredentials = true;
		request.timeout = 30000;
		request.setRequestHeader('Content-Type', 'application/json');

		request.onerror = function() {
			handleErrorState();
			refreshWebElements();
		};

		request.onload = function() {
			if (this.status >= 200 && this.status < 400) {
				// Success!
				var data = JSON.parse(this.response);

				if (data.account_expires_at) {
					setStorageItem('account_expires_at', new Date(data.account_expires_at).getTime());
				}

				setStorageItem('account_cleaned', data.account_data_deleted || false);
				setStorageItem('account_customer_type', data.customer_type);
				setStorageItem('account_fetched_on', Date.now());
				setStorageItem('account_logged_in', data.user_logged_in || false);
				setStorageItem('account_phase', data.account_phase);
				setStorageItem('country', data.country);
				setStorageItem('intercom_user_id', data.intercom_user_id);

				// Never store smaller number of trials count
				const trialsCount = getStorageItem('new_trials_count');
				const newTrialsCount = data.new_trials_count;
				if ((!trialsCount || newTrialsCount > trialsCount) && newTrialsCount) {
					setStorageItem('new_trials_count', newTrialsCount);
				}

				dataLayer.push({
					'event' : 'gaEvent',
					'eventCategory' : 'User',
					'eventAction' : 'Existing User Session',
					'userId' : data.intercom_user_id,
				});
			} else {
				handleErrorState();
			}

			refreshWebElements();
		}

		request.send();
	}

})();
